// @flow
const DEFAULT_LEFT_OFFSET = 0;

export const getLeftOffset = (offsetWidth: Array<number>, cellStartIndex: number): number => {
    return offsetWidth[cellStartIndex] || DEFAULT_LEFT_OFFSET;
};
